import $ from 'jquery';

// Require plugins
require('slick-carousel');

$(document).ready(() => {
	const $slider = $('.gallery__items');
	const $next = $('.gallery__controls #nextButton');
	const $prev = $('.gallery__controls #prevButton');

	$next.bind('click', () => {
		$slider.slick('slickNext');
	});

	$prev.bind('click', () => {
		$slider.slick('slickPrev');
	});

	$slider.slick({
		arrows: false,
		autoplay: true,
		pauseOnFocus: false,
		pauseOnHover: false,
	});
});
